import React, { useContext } from 'react';
import { BUTTON_LABELS, CustomFooter, EMPTY_OBJECT, ModalContext } from 'commons-ui';
import { IHandlerAction, IUserV2HandlerParams } from 'models/settingsV2.model';
import useHandler from '../useHandlers';
import { ACTION_IDS } from '../../../../settingsV2Constant';
import { ESettingV2URL } from '../../../../settingsV2Enum';

export const makeActionHandler = (action: IHandlerAction, params: IUserV2HandlerParams) => {
	const { history, rowData = EMPTY_OBJECT } = params;
	const { setModalConfig } = useContext(ModalContext);
	const { onAgreeDeleteUser, onDisAgreeDeleteUser } = useHandler(params);
	switch (action.id) {
		case ACTION_IDS.EDIT:
			return () => {
				history.push({
					pathname: ESettingV2URL.EDIT_USER_URL,
					state: {
						rowData
					}
				});
			};
		case 'delete':
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Delete User',
					content: 'Are you sure you want to delete this User?',
					footer: (
						<CustomFooter
							agreeLabel={BUTTON_LABELS.AGREE}
							disagreeLabel={BUTTON_LABELS.DISAGREE}
							onAgreeClick={onAgreeDeleteUser}
							onDisagreeClick={onDisAgreeDeleteUser}
						/>
					)
				});
			};
		case ACTION_IDS.ADD:
			return () => {
				history.push({
					pathname: ESettingV2URL.CREATE_USER_URL
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
